/* eslint-disable */
import { IState } from "@/interfaces/IState";
import axios from "axios";
import { IState } from "../../interfaces/IState";

export const activity = {
    state: {
        activities: [],
        activitiesByGroup: [],
        activity: {},
        info: [],
        activitiesTypes: []
    },
    mutations: {
        SET_ACTIVITIES(state: IState, payload: any) {
            state.activities = payload;
        },
        SET_INFO_ACTIVITIES(state: IState, payload: any) {
            state.info = payload;
        },
        ADD_ACTIVITIES(state: IState, payload: any) {
            state.activities.push(payload);
        },
        SET_ACTIVITIES_TYPES(state: IState, payload: any) {
            state.activitiesTypes = payload;
        },
        SET_ONE_ACTIVITY(state: IState, payload: any) {
            state.activity = payload;
        },
        RESET_ONE_ACTIVITY(state: IState, payload: any) {
            state.activity = {};
        },
        SET_ACTIVITIES_BY_GROUP(state: IState, payload: any) {
            state.activitiesByGroup = payload;
        },
    },
    actions: {
        async getActivitiesByLessonId(context: any, payload: any) {
            await axios
                .get(
                    `${axios.defaults.baseURL}activity/${payload}/lesson`
                )
                .then(res => {
                    console.info(
                        "Cargando Las actividades por LessonId",
                        res.data
                    );
                    context.commit("SET_ACTIVITIES", res.data);
                })
                .catch(error => {
                    console.info(
                        "Error al cargar las actividades por LessonId",
                        payload,
                        error
                    );
                });
        },
        async getActivitiesByGroupTypeLessonId(context: any, payload: any) {
            await axios
              .get(
                `${axios.defaults.baseURL}activity/student/{lessonId}?lessonId=${payload}`
              )
              .then((res: any) => {
                console.info("Cargando Las actividades por grupo", res.data);
                context.commit("SET_ACTIVITIES_BY_GROUP", res.data);
              })
              .catch((error: any) => {
                console.info(
                  "Error al cargar las actividades por LessonId",
                  payload,
                  error
                );
              });
          },
        // SAVE, UPDATE, DELETE ACTIONS
        async addNewActivity(context: any, payload: any) {
            console.info("--- Store-Function addNewActivity", payload);
            await axios
                .post(`${axios.defaults.baseURL}activity`, payload)
                .then(res => {
                    console.info("Exito al añadir nueva Actividad: ", res);
                    context.commit("ADD_ACTIVITIES", res.data);
                })
                .catch(error => {
                    console.info("Error al añadir nueva Actividad:", error);
                });
        },
        async actionUpdateActivity(context: any, payload: any) {
            console.info("--- Store-Function actionUpdateActivity", payload);
            await axios
                .put(`${axios.defaults.baseURL}activity`, payload)
                .then(res => {
                    console.info("Exito al modificar Actividad: ", res);
                    // context.commit("ADD_LESSON", res.data);
                })
                .catch(error => {
                    console.info("Error al modificar Actividad:", error);
                });
        },
        async actionDeleteActivity(context: any, payload: any) {
            console.info("--- Store-Function actionDeleteActivity", payload);
            await axios
                .delete(`${axios.defaults.baseURL}activity/${payload}`)
                .then(res => console.info("Exito al eliminar Actividad", res))
                .catch(error => console.info("Error al eliminar Actividad:", error))
        },
        // GET ACTIONS
        async getInfoByLessonId(context: any, payload: any) {
            await axios
                .get(
                    `${axios.defaults.baseURL}information/createActivity/${payload}`
                )
                .then(res => {
                    console.info(
                        "obteniendo la informacion por LessonId",
                        res.data
                    );
                    context.commit("SET_INFO_ACTIVITIES", res.data);
                })
                .catch(error => {
                    console.info(
                        "Error al cargar la informacion por LessonId",
                        error
                    );
                });
        },
        async actionGetActivitiesTypes(context: any) {
            await axios
                .get(`${axios.defaults.baseURL}activityType`)
                .then(res => {
                    console.info(
                        "obteniendo los tipos de actividades",
                        res.data
                    );
                    context.commit("SET_ACTIVITIES_TYPES", res.data);
                })
                .catch(error => {
                    console.info("Error los tipos de actividades", error);
                });
        },
        async actionGetActivity(context: any, payload: any) {
            await axios
                .get(`${axios.defaults.baseURL}activity/${payload}`)
                .then( res => {
                    console.info("Cargando Actividad", res.data);
                    context.commit("SET_ONE_ACTIVITY", res.data);
                })
                .catch(error => {
                    console.info("Error al cargar la Actividad", error);
                });  
        },

        // RESET ACTIONS

        actionResetActivity(context: any) {
            context.commit("RESET_ONE_ACTIVITY");
        },
        setActivities(context: any, payload: any) {
        console.log("Seteando actividades:",payload)
        context.commit("SET_ACTIVITIES", payload);
        }
    },
    getters: {
        getActivities(state: IState) {
            return state.activities;
        },
        getActivitiesByGroup(state: any) {
            return state.activitiesByGroup;
        },
        getActivitiesInfo(state: IState) {
            return state.info;
        },
        getActivitiesTypes(state: IState) {
            return state.activitiesTypes;
        },
        getActivity(state: IState) {
            return state.activity;
        }
    }
};
